import React, { Fragment, useEffect, useState } from "react";
import { api } from "../../_services/api.service";
import { Row, Col, Card, CardBody } from "reactstrap";
import PageTitle from "../../Layout/AppMain/PageTitle";
import GeneralGrid from "../../Components/GeneralGrid";
import Loader from "react-loaders";
import { CustomInput } from "reactstrap";
import AppCache from "../../_helpers/appCache";
import {userService} from '../../_services/user.service';

const PartnerList = (props) => {
  let [partnerList, setPartnerList] = useState([]);
  let [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const currentUser = userService.getLoggedInUser();
    if (currentUser.roleId != 110) {
      props.history.push('/login');
      return;
    }

    AppCache.clearPartner();
    setIsLoading(true);
    api.getAllPartners().then((data) => {
      setPartnerList(data);
      setIsLoading(false);
    });
  }, []);

  const goToDetails = (partnerId) => {
    props.history.push({
      pathname: `/partnersettings/${partnerId}`,
    });
  };

  const columns = [
    {
      dataField: "partnerName",
      text: "Account Name",
      headerStyle: () => {
        return { width: "30%" };
      },
      sort: true,
      formatter: (cellContent, row) => {
        return (
          <a
            key={row.partnerID}
            href="#"
            onClick={(e) => {
              e.preventDefault();
              goToDetails(row.partnerID);
            }}
          >
            {cellContent}
          </a>
        );
      },
    },
    {
      dataField: "partnerType",
      text: "Type",
      sort: true,
      headerStyle: () => {
        return { width: "25%" };
      },
    },
    {
      dataField: "description",
      text: "Description",
      sort: true,
      headerStyle: () => {
        return { width: "25%" };
      },
    },
    {
      dataField: "inactive",
      headerStyle: () => {
        return { width: "10%" };
      },
      text: "Inactive",
      sort: true,
      formatter: (cellContent, row) => {
        return (
          <CustomInput
            readOnly={true}
            type="checkbox"
            id={row.partnerID}
            checked={row.inactive}
          />
        );
      },
    },
  ];

  const defaultSorted = [
    {
      dataField: "partnerName",
      order: "asc",
    },
  ];

  const options = {
    sizePerPageList: [
      {
        text: "50",
        value: 50,
      },
    ],
    hideSizePerPage: true,
    hidePageListOnlyOnePage: true,
  };

  return (
    <Fragment>
      <PageTitle icon="fas fa-building" heading={"Business and Enterprise Accounts"} />
      {isLoading && <Loader style={{}} type="ball-pulse" active />}
      {!isLoading && (
        <Row style={{ marginBottom: "40px" }}>
          <Col md="11">
            <Card className="main-card mb-3">
              <CardBody>
                <GeneralGrid
                  title=""
                  keyField="partnerID"
                  defaultSortedColumn="partnerName"
                  dataSource={partnerList}
                  filterColumns={["partnerName", "partnerType"]}
                  columns={columns}
                  defaultSorted={defaultSorted}
                  options={options}
                  buttonText="Add Account"
                  onAdd={() => goToDetails(-1)}
                />
              </CardBody>
            </Card>
          </Col>
        </Row>
      )}
    </Fragment>
  );
};

export default PartnerList;
